// Generic bool <-> "Yes"/"No" radio casting.

// Unrecognized input (e.g. null/undefined from a field the backend omitted)
// falls back to "", this codebase's cleared-radio sentinel — for BOTH the
// legacy component-library Radio (defaultProps.value = "") and every current
// UI2 RadioGroup2 consumer. NOTE: react-aria-components itself documents
// `null` (not "") as the "no selection" value for RadioGroup — if this ever
// feeds a react-aria RadioGroup directly (not through an RHF-string field),
// re-check that "" still resolves to unselected there.
export const boolToRadio = (value: unknown): unknown => {
  if (value === true) return "Yes";
  if (value === false) return "No";

  return "";
};

// Unrecognized input (e.g. a cleared radio's "" sentinel) nullifies rather
// than passing through, since the field is expected to end up boolean|null.
export const radioToNullableBool = (value: unknown): Nullable<boolean> => {
  if (typeof value === "boolean") return value;
  if (value === null) return null;
  if (value === "Yes") return true;
  if (value === "No") return false;

  return null;
};
